import type { NextPage } from "next";
import Head from "next/head";
import Affiliations from "../components/affiliations";
import Approach from "../components/appoach";
import NotificationBanner from "../components/common/notification-banner";
import Contact from "../components/contact";
import Contribution from "../components/contribution";
import Feature from "../components/feature";
import FeatureTrial from "../components/feature-trial";
import Footer from "../components/footer";
import Hero from "../components/hero";
import Mission from "../components/mission";
import Navbar from "../components/navbar";
import Outreach from "../components/outreach";
import Press from "../components/press";
import Quote from "../components/quote";
import Updates from "../components/updates";
import { loadBannerEvent } from "../utils/events";
import { loadUpdates } from "../utils/updates";

const Home: NextPage = ({ updates, bannerEvent }: { updates?: any; bannerEvent?: any }) => {
  return (
    <div data-theme="winter">
      <Head>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <NotificationBanner event={bannerEvent || null} />
      <Navbar />
      <main style={{ scrollBehavior: "smooth" }}>
        <Hero />
        <Mission />
        <Approach />
        <FeatureTrial />
        <Contribution />
        <Feature />
        <Updates updates={updates} />
        <Outreach />
        <Quote />
        <Press />
        <Contact />
        <Affiliations />
        {/* <h1 className={styles.title}>
          Welcome to <a href="https://nextjs.org">Next.js!</a>
        </h1>

        <p className={styles.description}>
          Get started by editing{" "}
          <code className={styles.code}>pages/index.tsx</code>
        </p>

        <div className={styles.grid}>
          <a href="https://nextjs.org/docs" className={styles.card}>
            <h2>Documentation &rarr;</h2>
            <p>Find in-depth information about Next.js features and API.</p>
          </a>

          <a href="https://nextjs.org/learn" className={styles.card}>
            <h2>Learn &rarr;</h2>
            <p>Learn about Next.js in an interactive course with quizzes!</p>
          </a>

          <a
            href="https://github.com/vercel/next.js/tree/canary/examples"
            className={styles.card}
          >
            <h2>Examples &rarr;</h2>
            <p>Discover and deploy boilerplate example Next.js projects.</p>
          </a>

          <a
            href="https://vercel.com/new?utm_source=create-next-app&utm_medium=default-template&utm_campaign=create-next-app"
            className={styles.card}
          >
            <h2>Deploy &rarr;</h2>
            <p>
              Instantly deploy your Next.js site to a public URL with Vercel.
            </p>
          </a>
        </div> */}
      </main>

      <Footer />

      {/* <footer>
        <a
          href="https://vercel.com?utm_source=create-next-app&utm_medium=default-template&utm_campaign=create-next-app"
          target="_blank"
          rel="noopener noreferrer"
        >
          Powered by{" "}
          <span>
            <Image src="/vercel.svg" alt="Vercel Logo" width={72} height={16} />
          </span>
        </a>
      </footer> */}
    </div>
  );
};

export async function getStaticProps() {
  return {
    props: {
      bannerEvent: loadBannerEvent(),
      updates: loadUpdates(),
    },
  };
}

export default Home;
